import { FC } from 'react'

import { useAtomValue } from 'jotai'
import {
  ConfigFormTemplate,
  InputSelectControlField
} from 'Automations/nodeDefinitions/components'
import { startNodeTriggerTargetDefinition, StartNodeTrigger } from '..'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import { Config } from '.'
import { ConfigFormProps } from 'Automations/nodeDefinitions/types'
import { useApplyTemplate } from 'Automations/nodeDefinitions/templates'
import {
  useSetDefaultAutomationName,
  useStartNodeTriggerOptions
} from '../hooks'
import { edgesAtom } from 'Automations/automationEditor/atoms'

export const StartPlaceholderConfigForm: FC<ConfigFormProps> = ({ nodeId }) => {
  const { nodeData, updateNodeType, definition, validationErrors } =
    useNode<Config>({ nodeId })

  const { insertTemplate } = useApplyTemplate()
  const options = useStartNodeTriggerOptions()
  const { setDefaultAutomationName } = useSetDefaultAutomationName()
  const edges = useAtomValue(edgesAtom)

  if (!nodeData || !definition) return null

  return (
    <ConfigFormTemplate>
      <ConfigFormTemplate.Header nodeId={nodeId} />

      <ConfigFormTemplate.Row label="Type">
        <InputSelectControlField
          data-testid="automations.editor.configForm.start.trigger"
          placeholder="Select type..."
          options={options}
          onChange={trigger => {
            setDefaultAutomationName(trigger as StartNodeTrigger)

            const hasConnectedNodes = edges.some(
              edge => edge.source === nodeId || edge.target === nodeId
            )

            if (!hasConnectedNodes) {
              insertTemplate(trigger as StartNodeTrigger, nodeId)
              return
            }

            updateNodeType(
              startNodeTriggerTargetDefinition[trigger as StartNodeTrigger]
            )
          }}
          validationErrors={validationErrors.trigger}
        />
      </ConfigFormTemplate.Row>
    </ConfigFormTemplate>
  )
}
